import { j as r } from "../jsx-runtime-DywqP_6a.js";
const t = ({ children: e }) => /* @__PURE__ */ r.jsx("div", { className: "stepper", children: e });
export {
  t as Stepper
};
//# sourceMappingURL=Stepper.js.map
